export enum CampaignStatus {
  DRAFTED = 'drafted',
  TEMPLATE_PENDING = 'template_pending',
  TEMPLATE_REJECTED = 'template_rejected',
  TEMPLATE_FAILED = 'template_failed',
  CANCELED = 'canceled',
  FAILED = 'failed',
  INITIALIZED = 'initialized',
  PROCESSED = 'processed',
  SCHEDULED = 'scheduled',
  IN_PROGRESS = 'in_progress',
  MEDIA_PROCESSING = 'media_processing',
  MEDIA_TRANSCODING_FAILED = 'media_transcoding_failed',
  DELETED = 'deleted',
  SUBMITTED_FOR_APPROVAL = 'submitted_for_approval',
}

export enum CampaignDisplayStatus {
  DRAFTED = 'drafted',
  SENDING = 'sending',
  SCHEDULED = 'scheduled',
  ACTIVE = 'active',
  FAILED = 'failed',
  IN_REVIEW = 'in_review',
  NEEDS_APPROVAL = 'needs_approval',
  COMPLETE = 'complete',
}

export enum CampaignType {
  API = 'api',
  BIRTHDAY = 'birthday',
  STANDARD = 'standard',
  SURVEY = 'survey',
  TEST = 'test',
}

export enum ResponseTags {
  QUESTION = 'question',
  THANK_YOU = 'thank-you',
  LOVING = 'loving',
  HAPPY = 'happy',
  YES = 'yes',
  NO = 'no',
  TAPBACK = 'tapback',
  REPLIED_TO = 'replied-to',
}

export enum CreationSource {
  API = 'external_api',
}
